import React from "react";
import classNamesMaker from "classnames";
import styles from "./FixedAspectRatioContainer.module.css";
export var ASPECT_RATIOS = {
  W16_H9: "W16H9"
};
/**
 * Renders a visual container with an specific fix aspect ratio.
 * By default it will be 16:9.
 */
export var FixedAspectRatioContainer = function FixedAspectRatioContainer(_ref) {
  var children = _ref.children,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? ASPECT_RATIOS.W16_H9 : _ref$aspectRatio,
    className = _ref.className,
    dataSpacer = _ref.dataSpacer;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-spacer": dataSpacer
  }, /*#__PURE__*/React.createElement("div", {
    className: classNamesMaker(styles.fixedAspectRatioContainer, styles["fixedAspectRatioContainer--".concat(aspectRatio)])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.fixedAspectRatioContainer__inner
  }, children)));
};